import {
  Schema,
  entityId,
  entityType,
  rights,
  tripId,
  userId,
  shareableId,
} from './common_schema.js';

const MealTypes = ['breakfast', 'lunch', 'dinner', 'snacks'];

const id = Schema.Int;
const day = Schema.Int;
const meal = Schema.Enum(...MealTypes);
const idx = Schema.Int;
const food = Schema.String;
const quantity = Schema.Float;
const unit = Schema.String;

const schemaFields = {
  id,
  tripId,
  entityId,
  entityType,
  day,
  meal,
  idx,
  food,
  quantity,
  unit,

  userId,
  shareableId,
  rights,
};

const schema = {
  'add-menu-item': new Schema({
    entityId,
    day,
    meal,
    idx,
    food,
    quantity,
    unit,
  }),
  'change-menu-item': new Schema({
    entityId,
    id,
    day: Schema.Optional(day),
    meal: Schema.Optional(meal),
    idx: Schema.Optional(idx),
    food: Schema.Optional(food),
    quantity: Schema.Optional(quantity),
    unit: Schema.Optional(unit),
  }),
  'delete-menu': new Schema({
    entityId,
    day,
  }),
  'delete-menu-item': new Schema({
    entityId,
    id,
  }),
  'get-menu': new Schema({
    entityId,
  }),
  'get-foods': new Schema({}),
  'get-units': new Schema({}),
};

export { schema as MenuSchema, schemaFields as MenuSchemaFields, MealTypes };
